var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.payment.ref)+" "),(_vm.payment.details.originBookingId)?_c('span',[_vm._v("#"+_vm._s(_vm.payment.details.originBookingId))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }